import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import routes from '../constants/Routes';
import { useNavigate } from "react-router-dom"
import AdvertisementDetails from '../views/Advertising/AdvertisingList';
import CreateAdvertisementDetails from '../views/Advertising/CreateAdvertising';
import ContentLibrary from 'views/ContentLibrary';
import ScreenShot from 'views/ScreenShot';
import TemplateForm from '../views/TemplateDesign/TemplateForm';
import TemplateCardList from '../views/TemplateDesign/TemplateCardList';

import CampaignList from '../views/Campaign/CampaignList';
import CreateCampaign from '../views/Campaign/CreateCampaign';
import ViewCampaign from '../views/Campaign/ViewCampaign';
import EditCampaign from '../views/Campaign/EditCampaign';
import UserProfile from 'views/UserProfile/UserProfile';
import Refund from 'views/Refund';
import Feedback from 'views/Feedback/Feedback';
import CampaignAudit from 'views/Campaign/CampaignAudit';
import Layouts from 'views/Layouts/Layouts';
import Dashboard from 'views/Dashboard/DashboardParent';
import ClientReportParent from 'views/Reports/ClientReportParent';
import ClientReportParentRainbow from 'views/Reports/ClientReportParentRainbow';

// import EditAdvertisementDetails from '../views/Advertising/EditAdvertising'
// import ViewAdvertisementDetails from 'views/Advertising/ViewAdvertising'

const AppRouter = () => {
	const navigate = useNavigate();
	const [role] = useState<string>('client');
	const userDtails = localStorage.getItem('userDetails');

	let ClientReport = ClientReportParent;

	const parsedUserDetails = userDtails
		? JSON.parse(userDtails)
		: { data: { clientId: 1, id: 1, username: 'root' } };

	const isRainbowHospital = parsedUserDetails?.data?.username === 'rainbowhospitals';
	if(isRainbowHospital) {
		ClientReport = ClientReportParentRainbow;
	}

	return (

		<Routes>
			<Route path={routes.ADVERTISEMENT_DETAILS.path} element={<AdvertisementDetails />} />
			<Route path={routes.CREATE_ADVERTISEMENT_DETAILS.path} element={<CreateAdvertisementDetails />} />
			<Route path={routes.VIEW_ADVERTISEMENT_DETAILS.path} element={<CreateAdvertisementDetails />} />
			<Route path={routes.EDIT_ADVERTISEMENT_DETAILS.path} element={<CreateAdvertisementDetails />} />
			<Route path={routes.CONTENT_LIBRARY.path}
				element={<ContentLibrary
					isSelectable={false}
					role={role}
					mediaAssetType="all"
					adClientId={parsedUserDetails?.data?.clientId}
				/>} />
			<Route path={routes.SCREEN_SHOT.path} element={<ScreenShot />} />
			<Route path={routes.REFUND.path} element={<Refund />} />
			<Route path={routes.USER_PROFILE.path} element={<UserProfile />} />
			<Route path={routes.CAMPAIGN_LIST.path} element={<CampaignList />} />
			<Route path={routes.CREATE_CAMPAIGN.path} element={<CreateCampaign role={role} />} />
			<Route path={routes.VIEW_CAMPAIGN.path} element={<ViewCampaign />} />
			<Route path={routes.EDIT_CAMPAIGN.path} element={<EditCampaign />} />
			<Route path={routes.CAMPAIGN_LIST.path} element={<CampaignList role={role} />}/>
			<Route path={routes.CREATE_CAMPAIGN.path} element={<CreateCampaign role={role} />}/>
			<Route path={routes.VIEW_CAMPAIGN.path} element={<ViewCampaign role={role} />}/>
			<Route path={routes.EDIT_CAMPAIGN.path} element={<EditCampaign role={role} />}/>

			<Route path={routes.TEMPLATE.path} element={<Layouts />} />
			<Route path={routes.TEMPLATE_LIST.path} element={<TemplateCardList />} />
			<Route path={routes.CREATE_TEMPLATE.path} element={<TemplateForm />} />
			<Route path={routes.EDIT_TEMPLATE.path} element={<TemplateForm />} />
			<Route path={routes.VIEW_TEMPLATE.path} element={<TemplateForm />} />

			<Route path={routes.CAMPAIGN_AUDIT.path} element={<CampaignAudit />} />
			<Route path={routes.FEEDBACK.path} element={<Feedback />} />
			<Route path={routes.DASHBOARD.path} element={<Dashboard />} />
			<Route
				path={routes.REPORTS.path}
				element={<ClientReport apiFunction={function (api: string): Promise<any> {
					throw new Error('Function not implemented.');
				}} focusApiFunction={undefined} />}
			/>
			<Route path={routes.HOME.path} element={<Dashboard />} />
			{/* <Redirect from={routes.HOME.path} to={routes.DASHBOARD.path} /> */}
		</Routes>

	);
};

export default AppRouter;
